import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { BenefitDetailsResponse, RenewalPlanPeriodResponse, getBenefitDetails, getRenewalPlanPeriod } from 'core'
import getQsehraBenefitDesignState from 'core/application/adminDashboard/benefitDetails/qsehra/benefitDesignState'
import getQsehraDesignBenefitWizard from 'core/application/adminDashboard/benefitDetails/qsehra/benefitDesignWizard'

import { nowV2, toDateWithoutTimeZoneV2 } from '../../../../common/dateFormatters'
import { useQueryRequest, useQueryRequestV2 } from '../../../../common/hooks'
import { ROUTE_PATHS } from '../../../../common/routePaths'
import DesignBenefitWizard from '../common/DesignBenefitWizard'
import { NavItemsMapping, ReadonlyStepsWhenBenefitIsFinished } from './DesignStepsMapping'

const QsehraDesignBenefit: React.FC = () => {
  const history = useHistory()
  const { planPeriod } = useParams<any>()
  const { isLoading, sendQuery } = useQueryRequestV2<BenefitDetailsResponse>()
  const [hasNotificationDatePassed, setHasNotificationDatePassed] = useState<boolean>(false)

  const [, , sendGetRenewalPlanPeriod] = useQueryRequest<RenewalPlanPeriodResponse>(null)

  const goToDashboard = () => {
    history.push(`${ROUTE_PATHS.ADMIN_DASHBOARD_PATH}`)
  }

  useEffect(() => {
    ;(async () => {
      if (planPeriod) {
        const result = await sendQuery(() => getBenefitDetails(planPeriod))
        if (result?.notificationDate) {
          setHasNotificationDatePassed(nowV2() > toDateWithoutTimeZoneV2(result.notificationDate))
        }
      }
    })()
  }, [planPeriod])

  return (
    <DesignBenefitWizard
      getBenefitDesignWizard={(planPeriodId) => getQsehraDesignBenefitWizard(planPeriodId)}
      getBenefitDesignWizardState={(planPeriodId) => getQsehraBenefitDesignState(planPeriodId)}
      onDone={!hasNotificationDatePassed ? () => goToDashboard() : null}
      navItemsMapping={NavItemsMapping}
      readonlyStepsWhenBenefitIsFinished={ReadonlyStepsWhenBenefitIsFinished}
      onFinish={async (planPeriodId) => {
        const result = await sendGetRenewalPlanPeriod(() => getRenewalPlanPeriod())
        history.push(
          result?.id == planPeriodId ? `${ROUTE_PATHS.RENEWAL_TASKS}` : `${ROUTE_PATHS.ADMIN_DASHBOARD_PATH}`,
        )
      }}
    />
  )
}

export default QsehraDesignBenefit
